import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { DeleteAttachmentDialogProps } from './AttachmentsMacroDeleteDialog.tsx';

export const AttachmentsMacroDeleteDialogLoader: LoadableType<
	DeleteAttachmentDialogProps & DialogsContainerProps
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-attachments-macro-delete-dialog" */ './AttachmentsMacroDeleteDialog.tsx'
			)
		).DeleteAttachmentDialog,
});
